'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["fieldType", "startDrag", "endDrag"];
import { isEmpty } from 'underscore';
import { useEffect } from 'react';
import { useDrag } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { connect } from 'react-redux';
import { DragTypes } from 'FormsUI/constants/DragAndDrop';
import FieldDraggableBox from 'FormsCommonComponents/js/editor/draggable/FieldDraggableBox';
import { RichTextFieldTypes, PageField } from 'ui-forms-components/constants/FieldTypeMapping';
import { fieldTypesWithIcon, IconMapping, NewFieldIconMapping } from 'ui-forms-components/constants/propertyIcons';
import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import { startDrag, endDrag } from 'FormsUI/actions/DragState.ts';
import generateDefaultRichTextContent from 'FormsUI/utils/generateDefaultRichTextContent';
import { DRAGGED_NEW_FIELD_TILE } from 'FormsUI/constants/TrackingInteractionKeys/Editor/FormTab';
import { jsx as _jsx } from "react/jsx-runtime";
const DraggableFieldBox = props => {
  const {
      fieldType,
      startDrag: startDragAction,
      endDrag: endDragAction
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const [{
    isDragging
  }, dragRef, dragPreviewRef] = useDrag(() => ({
    type: DragTypes.NEW_FORM_FIELD,
    item: () => {
      trackEditorInteraction(DRAGGED_NEW_FIELD_TILE, {
        fieldType
      });
      startDragAction({
        type: 'newField',
        fieldType
      });
      return Object.assign({
        isCreateNewField: true,
        fieldType,
        propertyId: null,
        isPageBreak: fieldType === PageField
      }, !isEmpty(RichTextFieldTypes[fieldType]) && {
        richTextContent: generateDefaultRichTextContent(fieldType)
      });
    },
    end: () => {
      endDragAction();
    },
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  }), [fieldType]);

  // Hide default drag preview
  useEffect(() => {
    dragPreviewRef(getEmptyImage());
  }, [dragPreviewRef]);
  return /*#__PURE__*/_jsx("div", {
    ref: dragRef,
    children: /*#__PURE__*/_jsx(FieldDraggableBox, Object.assign({
      FieldIconMapping: IconMapping,
      fieldImageMapping: NewFieldIconMapping,
      fieldTypesWithIcon: fieldTypesWithIcon,
      fieldType: fieldType,
      isDragging: isDragging
    }, rest))
  });
};
const mapDispatchToProps = {
  startDrag,
  endDrag
};
export default connect(null, mapDispatchToProps)(DraggableFieldBox);